/* eslint-disable no-undef */
import router from '../router';
import axiosInstance from './instance';
import store from '../store';
import {CLEAR_USERDATA, GET_TOKEN} from '../store/modules/auth';

export {axiosInstance};
axiosInstance.defaults.headers.common['Accept-Language'] = (localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

// Add a response interceptor
export const responseInterceptor = axiosInstance.interceptors.response.use(
    (response) => {
        return Promise.resolve(response.data);
    },
    (error) => {
        if (error && error.response && error.response.status === 401 && router.currentRoute.name !== 'sign-in') {
            store.commit(CLEAR_USERDATA);
            router.push({ name: 'sign-in' });
        }
        return Promise.reject(error);
    }
);

// Add a request interceptor
export const requestInterceptor = axiosInstance.interceptors.request.use(
    (request) => {
        // Assign the refreshed token on every request.
        const token = store.getters[GET_TOKEN];
        if (token) {
            request.headers['Authorization'] = 'Bearer ' + token;
        }
        request.headers['X-Requested-With'] = 'XmlHttpRequest';
        return Promise.resolve(request);
    },
    (error) => {
        return Promise.reject(error);
    }
);



// WEBPACK FOOTER //
// ./src/api/index.js